import React from "react"

import Layout from "../components/layout"
import { Helmet } from "react-helmet"
import SEO from "../components/seo"
import Home from "../sections/home/home"
import Favours from "../sections/favours/favours"
import Portfolio from "../sections/portfolio/portfolio"
import "./global.scss"

const IndexPage = () => (
  <Layout>
    <Helmet>
      <title>IT Arnas | Visos programavimo paslaugos </title>
      <link
        href="https://fonts.googleapis.com/css?family=Raleway:400,700&display=swap"
        rel="stylesheet"
      ></link>
    </Helmet>
    <SEO title="Home" />
    <Home />
    <Favours />
    <Portfolio />
  </Layout>
)

export default IndexPage
